
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import Loader from "../../components/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export default function RowWebexIoT({ item }) {
  //import context
  const { apiUrl } = useContext(AuthContext);
  const [metrics, setMetrics] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();

  const metricsMap = {

    soundLevel: { name: "Niveau sonore", unit: "dbA" },
    ambientNoise: { name: "Bruit ambiant", unit: "dbA" },
    temperature: { name: "Température", unit: "°C" },
    humidity: { name: "Humidité", unit: "%" },
    tvoc: { name: "Qualité de l'air", unit: null },
    peopleCount: { name: "Nombre de personnes", unit: null }
  }

  const getMetricsOfWebex = () => {
    axios.get(`${apiUrl}webex/workspaces/metrics/${item.id}`, { withCredentials: true, })
      .then(res => {
        const rawMetrics = Array.isArray(res.data) && res.data.length > 0
          ? res.data
          : Array.isArray(item.storybookMetrics)
            ? item.storybookMetrics
            : [];

        const formatedData = rawMetrics.map((metric) => ({
          name: metricsMap[metric.metricName]?.name || metric.metricName,
          workspaceId: metric.workspaceId,
          supported: Boolean(metric.items?.[0]?.min ?? metric.items?.[0]?.mean ?? metric.items?.[0]?.max),
          unit: metricsMap[metric.metricName]?.unit || null,
          min: metric.items?.[0]?.min ?? null,
          max: metric.items?.[0]?.max ?? null,
          mean: metric.items?.[0]?.mean ?? null
        }));

        setMetrics(formatedData);
      })
      .catch(() => {
        const fallbackMetrics = Array.isArray(item.storybookMetrics)
          ? item.storybookMetrics.map((metric) => ({
            name: metricsMap[metric.metricName]?.name || metric.metricName,
            workspaceId: metric.workspaceId,
            supported: Boolean(metric.items?.[0]?.min ?? metric.items?.[0]?.mean ?? metric.items?.[0]?.max),
            unit: metricsMap[metric.metricName]?.unit || null,
            min: metric.items?.[0]?.min ?? null,
            max: metric.items?.[0]?.max ?? null,
            mean: metric.items?.[0]?.mean ?? null
          }))
          : [];

        setMetrics(fallbackMetrics);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getMetricsOfWebex()
  }, [item.id])

  return (
    <>
      {!isLoading ?
        <div className="webexIot-container">

          {metrics.filter(metric => metric.supported === true).length > 0 ? metrics.map((metric, index) => {
            if (item.id === metric.workspaceId && metric.supported) {
              return <div className="webexIot-item" key={index}>
                <p className="webexIot-content">
                  <span className="webexIot-title">{t(metric.name)} {t('moyen')}</span>
                  <div className="webexIot-content-data">
                    <span className="webexIot-data">{metric.mean}{metric.unit}</span>
                    <div className="webexIot-value_container">
                      <p className="webexIot-value">
                        <span className="webexIot-value_title"> Min <FontAwesomeIcon icon={faArrowDown} /></span>
                        <span className="webexIot-value_data">{metric.min ?? 0}{metric.unit}</span>
                      </p>
                      <p className="webexIot-value">
                        <span className="webexIot-value_title"> Max <FontAwesomeIcon icon={faArrowUp} /></span>
                        <span className="webexIot-value_data">{metric.max ?? 0}{metric.unit}</span>
                      </p>
                    </div>
                  </div>
                </p>
              </div>
            }
          }) :
            <p className="webexIot-nodata">{t("Aucune donnée")}</p>
          }

        </div> : <Loader />}
    </>
  );
}
